import React from 'react'
import { useNavigate } from 'react-router-dom'
import Navigation from '../../Layouts/Navigation/Navigation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved, faUsers, faUser } from '@fortawesome/free-solid-svg-icons'


function AdminUsers() {

  const navigate = useNavigate()

  const handleClick = (path) => {
    navigate(path)
  }

  const userTypes = [
    {
      title: 'Administradores',
      description: 'Gestionar usuarios administradores',
      icon: faUser,
      gradient: 'from-emerald-500 to-teal-600',
      path: '/adminAdministrators'
    },
    {
      title: 'Seguridad',
      description: 'Gestionar personal de seguridad',
      icon: faShieldHalved,
      gradient: 'from-blue-500 to-indigo-600',
      path: '/adminSecurity'
    },
    {
      title: 'Inquilinos',
      description: 'Gestionar residentes del conjunto',
      icon: faUsers,
      gradient: 'from-green-500 to-emerald-600',
      path: '/adminInquilinos'
    }
  ];

  return (
    <>
      <Navigation/>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-800 text-center mb-10">
            Administración de Usuarios
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {userTypes.map((type, index) => (
              <div
                key={index}
                onClick={() => handleClick(type.path)}
                className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden cursor-pointer"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${type.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`p-4 rounded-xl bg-gradient-to-br ${type.gradient} shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
                      <FontAwesomeIcon icon={type.icon} className="h-8 w-8 text-white" />
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-primary-600 transition-colors">
                    {type.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm">
                    {type.description}
                  </p>
                </div>
                
                <div className={`h-1 w-0 group-hover:w-full bg-gradient-to-r ${type.gradient} transition-all duration-500`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminUsers
